module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1) : _c('GChart', {
    ref: "gChart",
    attrs: {
      "type": "ColumnChart",
      "settings": _vm.chartSettings,
      "data": _vm.data,
      "options": _vm.chartOptions,
      "resizeDebounce": 1000,
      "events": _vm.chartEvents
    }
  })
},staticRenderFns: []}